import configs from "../configs/apiConfigs";
import { METHOD_TYPE, CommonApiOptions, BODY_TYPE } from "../constants/api";
import { commonApi } from "../helpers/api";
import { attachHeader } from "../utils/apiHandler";

interface LostLeadsParams {
  clinicUniqueId: string;
  startDate: string;
  endDate: string;
}

export const fetchLostLeads = async (params: LostLeadsParams) => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}lostleadlist-report/${params.clinicUniqueId}/?startDate=${params.startDate}&endDate=${params.endDate}`,
    method: METHOD_TYPE.GET,
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };
  return commonApi(request);
};

export const updateLostLeadReason = async (
  clinicUniqueId: string,
  lostLeadId: number,
  data: any
): Promise<any> => {
  const request: CommonApiOptions = {
    url: `${configs.API_URL}updatenote/${clinicUniqueId}/${lostLeadId}/`,
    method: METHOD_TYPE.POST,
    body: {
      type: BODY_TYPE.RAW,
      data: data,
    },
    apiOptions: {
      headers: attachHeader(true),
      withCredentials: true,
    },
  };

  return commonApi(request);
};
